"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphireMapperLinearFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphireMapperLinearFactory = /** @class */ (function (_super) {
    __extends(MockSapphireMapperLinearFactory, _super);
    function MockSapphireMapperLinearFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphireMapperLinearFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphireMapperLinearFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphireMapperLinearFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphireMapperLinearFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphireMapperLinearFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphireMapperLinearFactory;
}(contracts_1.ContractFactory));
exports.MockSapphireMapperLinearFactory = MockSapphireMapperLinearFactory;
var _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "_score",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_scoreMax",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_lowerBound",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_upperBound",
                type: "uint256",
            },
        ],
        name: "map",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_result",
                type: "uint256",
            },
        ],
        name: "setMapResult",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060d68061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80638a60d2e1146037578063cfc480c4146075575b600080fd5b606360048036036080811015604b57600080fd5b50803590602081013590604081013590606001356091565b60408051918252519081900360200190f35b608f60048036036020811015608957600080fd5b5035609c565b005b600054949350505050565b60005556fea265627a7a72315820e5ebc73513c0098d7498d54815a60e14b2ef963a58744728afb656c0c838d34e64736f6c63430005100032";
//# sourceMappingURL=MockSapphireMapperLinearFactory.js.map